import React, { Component } from 'react'
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { connect } from 'shalala';
import { Http } from '../../../../../support';
import { useStore } from '../../../../../store';
import LoadingButton from '../../../../../facturotopia/LoadingButton';

class ReceptoresFileItemActions extends Component {

  handleOnDownloadActionClick = async (original = undefined) => {
    try {
      const response = await Http.get(`${window.BONJOUR_URL}/api/receptores/${this.props.selectedRows[0].id}/download`, { responseType: 'blob' });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo original'
      });
    }
  }

  handleOnDownloadOriginalFile = async () => {
    try {
      const response = await Http.get(`${window.BONJOUR_URL}/api/excel-files/${this.props.selectedRows[0].id}`, { responseType: 'blob' });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo original'
      });
    }
  }

  render() {
    const { alignRight, selectedRowKeys } = this.props;
    const { actionBusy: busy } = this.props;

    return (
      <>
        { selectedRowKeys.length === 1 && (
          <Dropdown as={ ButtonGroup } alignRight={ alignRight }>
              <LoadingButton
                variant="secondary"
                loading={ busy }
                onClick={ this.handleOnDownloadActionClick.bind(this, undefined) }
              >
                { busy === true ? 'Descargando' : 'Descargar' }
              </LoadingButton>

            <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />

            <Dropdown.Menu>
              <Dropdown.Item as="div" onClick={ this.handleOnDownloadOriginalFile.bind(this) }>Descargar original</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </>

    )
  }
}

const mapState = (store) => {
  return {
    actionBusy: store.app.receptores.archivos.actionBusy,
  }
};

const mapActions = (actions, containers) => {
  return {
    download: actions.app.receptores.archivos.download,
  };
};

export default connect(useStore, mapState, mapActions)(ReceptoresFileItemActions);